<template>
  <div>
    <h4 class="text-sm font-semibold text-nera-text mb-2">{{ title }}</h4>
    <div class="flex flex-col gap-2">
      <FileItem
        v-for="file in files"
        :key="file.id"
        :file="file"
        @remove="$emit('remove', file.id)"
      />
    </div>
  </div>
</template>

<script setup>
import FileItem from './FileItem.vue'

defineProps({
  files: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    default: 'Files'
  }
})

defineEmits(['remove'])
</script>
